__webpack_require__.p = "/design-check-2fa-nxdywg/referrals/";